import { Epoch, ScheduleOfActivities } from '@faro/study-designer-model';
import { ENTIRE_STUDY } from '../../component/TimeRangeSelect/TimeRangeSelect';
import { PersonaCostType, SiteCategory } from '../../page/studies/:id/MetricsPage/Models';
import { personaCostTypeValues } from '../../page/studies/:id/MetricsPage/Utilties/PersonaCostTypeHelpers';

export const isPersonaCostTypeValid = (personaCostType: PersonaCostType): boolean => {
    return personaCostTypeValues.includes(personaCostType);
};

export const isSiteCategoryValid = (siteCategory: SiteCategory, personaCostType: PersonaCostType): boolean => {
    if (personaCostType === 'site_time') {
        return siteCategory === 'Investigator' || siteCategory === 'Study Coordinator';
    }

    if (personaCostType === 'site_relativeValueUnits') {
        return (
            siteCategory === 'Schedule Complexity' ||
            siteCategory === 'Investigator' ||
            siteCategory === 'Study Coordinator'
        );
    }

    return siteCategory === undefined;
};

export const isSoAIdValid = (soaId: string | undefined, schedules: ScheduleOfActivities[] | undefined): boolean => {
    if (soaId === undefined || schedules === undefined) return false;
    return schedules.some(schedule => schedule.id === soaId);
};

export const isTimeframeValid = (timeframe: string[], epochs: Epoch[]): boolean => {
    // If the timeframe is empty, it is not valid
    if (timeframe.length === 0) return false;

    // If the timeframe is ENTIRE_STUDY, it is valid
    if (timeframe.length === 1 && timeframe[0] === ENTIRE_STUDY) return true;

    // If all the ids in the timeframe are in the epochs, it is valid
    return timeframe.every(id => epochs.some(epoch => epoch.id === id));
};
